export enum TypeOrder {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  SUPER = 'SUPER',
  KOREA = 'KOREA',
  CARGO = 'CARGO',
}
